import styled from "@emotion/styled";
import { colorGuide } from "../../theme/colors";
import { generateTextStyles } from "../../utils";

export const SearchWrapper = styled.div<{
  isFocused: boolean;
  hasValue: boolean;
}>`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 448px;
  padding: 10px 12px;
  border-radius: 20px;
  gap: 8px;
  border: 1px solid
    ${(props) =>
      props.isFocused
        ? colorGuide.lightComponents.searchInput.focused.borderColor
        : colorGuide.lightComponents.searchInput.borderColor};
  position: relative;
  cursor: text;
`;
export const SearchFieldLabel = styled.label`
  position: absolute;
  pointer-events: none;
  display: block;
  margin: 0;
  padding: 0;
  line-height: normal;
  left: 36px;
`;
export const SearchInputField = styled.input`
  width: 100%;
  box-sizing: border-box;
  border: none;
  background: transparent;
  ${generateTextStyles({
    type: "body",
    fontWeight: "regular",
    variant: 5,
    color: colorGuide.lightComponents.searchInput.color,
  })}

  &:focus {
    outline: none;
  }

  ::placeholder {
    ${generateTextStyles({
      type: "body",
      fontWeight: "regular",
      variant: 5,
      color: colorGuide.lightComponents.searchInput.color,
    })}
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  padding: 2px;
  justify-content: center;
  align-items: center;
  gap: 20px;
`;

export const ClearIconWrapper = styled.div`
  display: flex;
  padding: 2px;
  justify-content: center;
  align-items: center;
  gap: 20px;
  cursor: pointer;
`;
